import styled from "styled-components";
import { useTranslation, Trans } from 'react-i18next';


const GalleryItem = styled.div`
    padding: 40px;
    display: flex;
    flex-direction: column;
    //css variable
    --gallery-item-border-radius: 1rem;

    img{
        max-width: 100%;
        max-height: 100%;
        border: 0px
    }
    img:first-of-type, iframe:first-of-type{
        border-top-left-radius: var( --gallery-item-border-radius);
        border-top-right-radius: var( --gallery-item-border-radius);
    }
    img:last-of-type, iframe:first-of-type{
        border-bottom-left-radius: var( --gallery-item-border-radius);
        border-bottom-right-radius:var( --gallery-item-border-radius);
    }

    iframe{
        width: 100%;
        aspect-ratio: 16/9;
        border: 0px
    }

    a{
        text-decoration: underline;
    }
`
const GalleryDescription = styled.div`
    padding: 12px;
    text-align: justify;
    color: white;
`

const GalleryFlavorText = styled.span`
    font-size: 0.9rem;
    color: lightgray;
    font-style: italic;
`

const GalleryStructuredDataUl = styled.ul`
    font-size: 0.9rem;
    color: lightgray;
    li{
        list-style: none;
        font-family: monospace;
    }
    text-align: left;
`

const GalleryColumn = styled.div`

    display: flex;
    flex-direction: column;
    flex: 1;
`
const Gallery = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 1100px) {
        flex-direction: column;
    }
`

const ResponsiveIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`

const ResponsiveIframeWrapper = styled.div`
  position: relative;
  overflow: hidden;
        aspect-ratio: 16/9;
`

const HorizontalRuler = styled.div`
    margin: 12px 24px;
    border-top: gray 1px solid;
    /* width: 100%; */
`

function GalleryStructuredData(props: { software?: String, hardware?: String, year: String }) {
    return <GalleryStructuredDataUl>
        <li><Trans i18nKey="threeD.software">Software</Trans>: {props.software}</li>
        {props.hardware && <li><Trans i18nKey="threeD.hardware">Hardware</Trans>: {props.hardware}</li>}
        <li><Trans i18nKey="threeD.year">Year</Trans>: {props.year}</li>
    </GalleryStructuredDataUl>
}
export default function ThreeD() {

    useTranslation();

    return <>
        <Gallery>
            <GalleryColumn>
                <GalleryItem>
                    <img src="https://i.imgur.com/rT9RffT.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.cesfur">
                                Illustration for Česfur 2022 conbook. Read more <a href="https://www.cesfur.org/">here</a>.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2022"} software="Blender, Zbrush, Photoshop" />
                </GalleryItem>
                <GalleryItem>
                    <ResponsiveIframeWrapper><ResponsiveIframe src="https://player.vimeo.com/video/673948488?h=b67cd7e12b" allow="autoplay; fullscreen; picture-in-picture" /></ResponsiveIframeWrapper>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.minsk">
                                3D models, animations and physics simulations for exhibition titled 'Brno→Minsk 1941'. The assets were used by artist Jana Francová for live videomapping session on the Constitutional Court building in Brno. Read more <a href="https://www.muni.cz/en/research/publications/1822919">here</a>.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2021"} software="Blender" />

                </GalleryItem>

                <GalleryItem>
                    <img src="https://i.imgur.com/HSjyCde.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.nanachi">
                                Avatar for VRChat. Fully rigged, including facial animation. Character is Nanachi from anime series Made in Abyss.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2023"} software="Blender, Substance Painter, Unity" />
                </GalleryItem>

                <GalleryItem>
                    <img src="https://i.imgur.com/oDes7cb.jpg"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.soncup">
                                Soncup. Personal project.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2021"} software="Blender, Photoshop" />

                </GalleryItem>

                <GalleryItem>
                    <img src="https://i.imgur.com/tjAWyD8.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.pixelartstuff">Part of a pixelart asset pack. Made for a game (not yet released).</Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2023"} software="Blender, Aesprite" />
                </GalleryItem>
            </GalleryColumn>
            <GalleryColumn>

                <GalleryItem>
                    <img src="https://i.imgur.com/BVBIUpp.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.hand">
                                Asset for rogalo simulator HCI research project. Sculpted, retopologized and rigged in Blender. Read more <a href="https://www.muni.cz/vyzkum/publikace/1817925">here</a>.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2021"} software="Blender" />

                </GalleryItem>


                <GalleryItem>
                    <img src="https://i.imgur.com/E3rXgam.png"></img>
                    <img src="https://i.imgur.com/7g8veiR.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.brani">
                                Brani the harbor seal. Personal project.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2022"} software="Blender, Zbrush, Substance Painter, Photoshop" />

                </GalleryItem>

                <GalleryItem>
                    <img src="https://i.imgur.com/UbNgv63.jpg"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.bulb">Procedural bulb. Asset made for teaching curves and modifiers.</Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2021"} software="Blender" />

                </GalleryItem>
                {/* <GalleryItem>
                    <img src="https://i.imgur.com/sWCIhqq.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.gerontosaurus">Gerontosaurus. He forgot his dentures. Personal project.</Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2018"} software="Zbrush, Photoshop" />

                </GalleryItem> */}

                <GalleryItem>
                    <img src="https://i.imgur.com/fbfPEBv.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.bulbus">
                                Canis bulbus, 3D printed lamp. Sculpted and posed in ZBrush, further processed in Blender and Meshmixer. Touching his tail turns him on. Sold at charity auction at Cesfur 2022.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2022"} software="Zbrush, Blender, Meshmixer" hardware="Prusa i3 MK3S+, Soldering iron" />
                </GalleryItem>
            </GalleryColumn>
        </Gallery>
        <HorizontalRuler />
        <Gallery>
            <GalleryColumn>
                <GalleryItem>
                    <img src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeHNjemU2bDhhMms4c2p6cTE1M25uamp0cHo1cndpd3V1dHFjYzdmcCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/6tRDR9ZNMzqUkjzyBM/giphy.gif" />
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.lamp">
                                SDF-based pixelart shader for a lavalamp. Made for a game (not yet released).
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2023"} software="Godot, OpenGL" />
                </GalleryItem>

                <GalleryItem>
                    <img src="https://i.imgur.com/VBOqbYX.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.drapi">Digitization and digital restoration of an animal costume head, preparation for 3D printing. Shape obtained using using photogrammetry, furhter cleaned and retopologized in ZBrush and Blender.</Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2022"} software="Meshroom, ZBrush, Blender" />
                </GalleryItem>

                <GalleryItem>
                    <ResponsiveIframeWrapper><ResponsiveIframe src="https://player.vimeo.com/video/850377785?h=82a9f7b884" allow="autoplay; fullscreen; picture-in-picture" /></ResponsiveIframeWrapper>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.musicalVRchat">
                                System for VRChat that allows users to control animations using MIDI instrument. In development in collaboration with my student.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2023"} software="Unity, Blender" />

                </GalleryItem>
     

            </GalleryColumn>
            <GalleryColumn>
                <GalleryItem>
                    <img src="https://i.imgur.com/zRx0p9d.png" />
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.brain">
                                In collaboration with Visitlab, used photogrammetry techniques to digitize the inventory of The Department of Anatomy of Masaryk University. This render depicts right hemisphere of the human brain.
                            </Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2021"} software="Meshroom, Blender" />
                </GalleryItem>

                <GalleryItem>
                    <img src="https://i.imgur.com/HqPlZFz.png"></img>
                    <GalleryDescription>
                        <GalleryFlavorText>
                            <Trans i18nKey="threeD.isostack">IsoStack. Blender addon using graph isomorphism solvers for stacking UV islands that share the topology, but not necessairly the shape. In development.</Trans>
                        </GalleryFlavorText>
                    </GalleryDescription>
                    <GalleryStructuredData year={"2023"} software="Blender" />
                </GalleryItem>
            </GalleryColumn>

        </Gallery>
    </>
}